import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DefaultAlert } from '~alert';
import Container from './Container';
import MessageWrapper from './MessageWrapper';

var FreeDeliveryAlert = function FreeDeliveryAlert(_ref) {
  var inProp = _ref.inProp;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DefaultAlert, {
    alertType: "info",
    inProp: inProp,
    transitionTimeout: {
      enter: 500
    }
  }, /*#__PURE__*/React.createElement(MessageWrapper, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.freeShippingAlert.message"
  }))));
};

FreeDeliveryAlert.defaultProps = {
  inProp: false
};
export default FreeDeliveryAlert;